import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderBurgerNav,
  HeaderFavorites,
  HeaderLogo,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndNavMobile = () => (
  <>
    <HeaderRow borderless type="small">
      <HeaderSection justify="start">
        <HeaderBurgerNav />
        <SearchHeader withEmbeddedInput />
      </HeaderSection>
      <HeaderSection justify="center">
        <HeaderLogo center fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndNavMobile };
